import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { Message } from 'primeng/api';
import { OPCConstant } from '../../../opc-app/opc.const';
import { ProductService } from '../../../shared/services/product.service';
import { ProductLine } from '../../../opc-app/productline/productline.model';
import { ProductFamily } from '../../../opc-app/productfamily/productfamily.model';
import { NotificationService } from '../../../shared/services/notification.service';
import { FormGroup, FormControl, Validators, FormBuilder, AbstractControl } from '@angular/forms';
import { OPCSettings } from '../../../shared/models/opcsettings.model';

@Component({
    selector: 'app-productline-item',
    templateUrl: './productline-item-component.html'
})
export class ProductLineItemComponent implements OnInit {
    @Input() productLine: ProductLine;
    @Input() i: string;
    @Output() isSubmited: EventEmitter<any> = new EventEmitter();
    @Output() isDeleted: EventEmitter<any> = new EventEmitter();
    @ViewChild('fileUpload')
    fileUpload: any;
    cloneProductLine: ProductLine;
    file: any;
    notifications: Message[] = [];
    plName: string;
    vintageStart: number;
    vintageEnd: number;
    productFamilies: ProductFamily[];
    byPassFamilyName: string;
    plFormGroup: FormGroup;
    descField: FormControl;
    codeField: FormControl;
    vintagestartField: FormControl;
    vintageendField: FormControl;
    associatePF: FormControl;
    showImage: boolean;
    productLineImgPath: string;
    opcSettings: OPCSettings = new OPCSettings();

    constructor(private _productService: ProductService, private confirmationService: ConfirmationService,
        private notifyService: NotificationService, private fb: FormBuilder) {
        this.byPassFamilyName = OPCConstant.BYPASS_FAMILY;
    }

    ngOnInit() {
        this.cloneProductLine = Object.assign({}, this.productLine);
        this.plName = this.productLine.productLineDesc ? this.productLine.productLineDesc : '';
        this.vintageStart = this.productLine.vintageStart ? parseInt(this.productLine.vintageStart.toString().substr(0, 4), 10) : undefined;
        this.vintageEnd = this.productLine.vintageEnd ? parseInt(this.productLine.vintageEnd.toString().substr(0, 4), 10) : undefined;
        this.productFamilies = this._productService.productFamilies.filter(p => p.productFamilyName !== this.byPassFamilyName);
        this.showImage = false;
        this.defaultDropDown();
        this.formControlValidation();
        this.formGroupValidation();
    }
    formControlValidation() {
        const numPattern = '^[1-9][0-9]*$';
        this.descField = new FormControl('', [
            Validators.required,
            Validators.maxLength(60),
            Validators.minLength(3)
        ]);
        this.codeField = new FormControl('', [
            Validators.required,
            Validators.maxLength(6),
            Validators.minLength(2)
        ]);
        this.vintagestartField = new FormControl('', [
            Validators.required,
            Validators.maxLength(4),
            Validators.minLength(4),
            Validators.pattern(numPattern)
        ]);
        this.vintageendField = new FormControl('', [
            Validators.maxLength(4),
            Validators.minLength(4),
            Validators.pattern(numPattern)
        ]);
        this.associatePF = new FormControl('', [
            Validators.required
        ]);
    }
    formGroupValidation() {
        this.plFormGroup = this.fb.group({
            descField: this.descField,
            codeField: this.codeField,
            vintagestartField: this.vintagestartField,
            vintageendField: this.vintageendField,
            associatePF: this.associatePF
        },
            {
                validator: this.vintageValidation
            }
        );
    }
    vintageValidation(ac: AbstractControl) {
        const date = new Date();
        if ((ac.get('vintagestartField').value && ac.get('vintageendField').value
            && (parseInt(ac.get('vintagestartField').value) >= parseInt(ac.get('vintageendField').value)))
            || (ac.get('vintagestartField').value && !ac.get('vintageendField').value
                && (parseInt(ac.get('vintagestartField').value) > date.getFullYear()))) {
            ac.get('vintageendField').setErrors({
                VintageFailure: true
            });
        } else {
            ac.get('vintageendField').setErrors(null);
            return null;
        }
    }
    onUpload(event) {
        const fileBrowser = this.fileUpload.nativeElement;
        if (fileBrowser.files && fileBrowser.files[0]) {
            this.file = fileBrowser.files[0];
        }
        if (!(this.file.size > this.opcSettings.minImageSize
            && this.file.size < this.opcSettings.maxImageSize
            && this.file.type === this.opcSettings.validImageFormat)) {
            this.notifications = this.notifyService.growlNotification('warn', OPCConstant.INVALID_IMAGE_UPLOAD);
            event.srcElement.value = '';
            this.file = undefined;
        }
    }
    onShowImage() {
        this.showImage = true;
    }
    onSubmit() {
        if (this.plFormGroup.valid) {
            this.productLine.vintageStart = this.vintageStart + '-01-01 00:00:01.0000000';
            this.productLine.vintageEnd = this.vintageEnd ? this.vintageEnd + '-01-01 00:00:01.0000000' : undefined;
            if (!this.plName) {
                this._productService.addOrupdateProductLine(this.productLine, this.file, true).subscribe(res => {
                    this.isSubmited.emit(res);
                },
                    error => {
                        this.isSubmited.emit(undefined);
                        this.notifications = this.notifyService.growlNotification('fail', OPCConstant.UPDATE_FAILURE);
                    }
                );
            } else {
                this._productService.addOrupdateProductLine(this.productLine, this.file, false).subscribe(res => {
                    this.isSubmited.emit(res);
                },
                    error => {
                        this.isSubmited.emit(undefined);
                        this.notifications = this.notifyService.growlNotification('fail', OPCConstant.UPDATE_FAILURE);
                    }
                );
            }
        } else {
            this.notifications = this.notifyService.growlNotification('warn', OPCConstant.UPDATE_WARNING);
        }
    }
    onExpand() {
        // TO DO
    }
    onDelete(item: number, index: string) {
        if (item) {
            this.confirmationService.confirm({
                header: 'Delete Confirmation',
                key: index,
                message: OPCConstant.CONFIRM_MESSAGE,
                accept: () => {
                    this._productService.deleteProductLine(item).subscribe(
                        res => {
                            this.isDeleted.emit(true);
                        },
                        error => {
                            this.isDeleted.emit(false);
                            this.notifications = this.notifyService.growlNotification('fail', OPCConstant.PL_DELETE_FAILURE);
                        }
                    );
                }
            });
        } else {
            this.isDeleted.emit(true);
        }
    }
    defaultDropDown() {
        this.productLine.productFamilyID = this.productFamilies.find(p => p.productFamilyID === this.productLine.productFamilyID)
            ? this.productLine.productFamilyID : undefined;
    }
    onReset() {
        this.productLine = Object.assign({}, this.cloneProductLine);
        this.vintageStart = this.productLine.vintageStart ? parseInt(this.productLine.vintageStart.toString().substr(0, 4), 10) : undefined;
        this.vintageEnd = this.productLine.vintageEnd ? parseInt(this.productLine.vintageEnd.toString().substr(0, 4), 10) : undefined;
        this.defaultDropDown();
        this.fileUpload.nativeElement.value = '';
        this.file = undefined;
        if (!this.productLine.productLineID) {
            this.plFormGroup.reset();
        }
    }
}



// WEBPACK FOOTER //
// ./src/opc/opc-admin/productline/productline-item/productline-item-component.ts